"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CausalHistoryState = void 0;
const model_1 = require("../../../../data/model");
class CausalHistoryState extends model_1.HashedObject {
    constructor(mutableObj, terminalOpHistories) {
        super();
        this.mutableObj = mutableObj;
        if (terminalOpHistories !== undefined) {
            this.terminalOpHistories = new model_1.HashedSet(new Set(terminalOpHistories).values());
        }
        else {
            this.terminalOpHistories = new model_1.HashedSet();
        }
    }
    static async createFromTerminalOps(mutableObj, terminalOps, store) {
        const terminalOpHistories = [];
        for (const opHash of terminalOps) {
            const history = await store.loadOpCausalHistory(opHash);
            terminalOpHistories.push(history === null || history === void 0 ? void 0 : history.causalHistoryHash);
        }
        return CausalHistoryState.create(mutableObj, terminalOpHistories);
    }
    static create(target, terminalOpHistories) {
        return new CausalHistoryState(target, terminalOpHistories);
    }
    getClassName() {
        return CausalHistoryState.className;
    }
    async validate(_references) {
        if (this.mutableObj === undefined) {
            return false;
        }
        if (this.terminalOpHistories === undefined || !(this.terminalOpHistories instanceof model_1.HashedSet)) {
            return false;
        }
        for (const hash of this.terminalOpHistories.values()) {
            if (typeof (hash) !== 'string') {
                return false;
            }
        }
        return true;
    }
    init() {
    }
}
exports.CausalHistoryState = CausalHistoryState;
CausalHistoryState.className = 'hhs/v0/CausalHistoryState';
model_1.HashedObject.registerClass(CausalHistoryState.className, CausalHistoryState);
//# sourceMappingURL=CausalHistoryState.js.map